export default __webpack_public_path__ + "static/media/ico_log_out.95837113.svg";